import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useSearchBarStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex'
    },

    button: {
      marginLeft: 32,
      display: 'flex',

      [theme.breakpoints.down('md')]: {
        display: 'none'
      }
    },

    action: {
      cursor: 'pointer'
    }
  })
)
